import React, { Component } from 'react';
import { connect } from 'react-redux';
import { SORT_DESC } from 'ra-core/lib/reducer/admin/resource/list/queryReducer';
import Refresh from '../../../components/Refresh';
import CustomerDatagrid from './Datagrid';
import EjectedList from '../../../components/ejected/List';

import CreateComponent from './Create';
import EditComponent from './Edit';
import Header from './Header';

class List extends Component {
  constructor(props) {
    super(props);

    this.state = {
      roles: [
        { name: 'Админ', id: 'administrator' },
        { name: 'ЮР Руководитель', id: 'company_admin' },
        { name: 'ЮР Менеджер', id: 'company_manager' },
        { name: 'КЦ Руководитель', id: 'callcenter_admin' },
        { name: 'КЦ Менеджер', id: 'callcenter_manager' },
        { name: 'Админ ОКК', id: 'qcd_admin' }
      ]
    };
  }

  getTitle() {
    return 'Юридические компании';
  }

  render() {
    const defaultValues = {operator_fee: 0, leadCost: 1100, chief_fee: 0, director_fee: 0, cityId: '58a4869b5149740f80304564'};
    const create = (handleSubmit) => <CreateComponent onSubmit={handleSubmit} record={defaultValues} roles={this.state.roles} />;
    const edit = (handleSubmit, record) => <EditComponent onSubmit={handleSubmit} record={record} roles={this.state.roles} />;

    return (
      <div className="col-wrapper">
        <EjectedList
          {...this.props}
          title={this.getTitle()}
          sort={{ field: '_createdAt', order: SORT_DESC }}
          perPage={50}
          actions={<Refresh />}
          bulkActions={false}
          style={{ width: '1280px' }}
          headercomponent={Header}
          companies={this.props.companies}
        >
          <CustomerDatagrid
            edit={edit}
            create={create}
            companies={this.props.companies}
            callcenters={this.props.callcenters}
            city={this.props.city}
            roles={this.state.roles}
          />
        </EjectedList>
      </div>
    );
  }
}

export default connect(state => ({
  companies: state.sc.companies,
  callcenters: state.sc.callcenters,
  city: state.sc.city,
}), {})(List);



// WEBPACK FOOTER //
// ./src/pages/callcenter/company/List.js